import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Box, Grid, Typography } from "@mui/material";
import Header from "../../components/Header";
import { getCoveredMedicationsAndDrugsById } from "./../../ApiConfig.jsx";

function ViewCoveredMedicationsAndDrugs() {
  const { id } = useParams();
  const [itemDetails, setItemDetails] = useState({});
  const fetchData = async (id) => {
    try {
      const data = await getCoveredMedicationsAndDrugsById(id);
      console.log("🚀 ~ fetchData ~ data:", data)
      if (data.success==="true") {
        console.log(data.data);
        setItemDetails({
          Name: data.data.name,
          Reference: data.data.reference,
          "Drug category": data.data.drugCategory,
          Covered: data.data.isCovered ? "Yes" : "No",
          "Posted date": new Date(data.data.createdAt)
            .toISOString()
            .split("T")[0],
        });
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchData(id);
  }, [id]);

  return (
    <Box m="20px" height="70vh" overflow="auto" paddingRight="20px">
      <Header title={`View Covered Medications And Drugs ${id}`} subtitle="" />
      <Box ml={"40px"}>
        <Grid container spacing={2}>
          {Object.entries(itemDetails).map(([field, value]) => (
            <React.Fragment key={field}>
              <Grid item xs={3}>
                <Typography variant="h5" component="span" fontWeight="bold">
                  {field}:
                </Typography>
              </Grid>
              <Grid item xs={9}>
                <Typography>{value}</Typography>
              </Grid>
            </React.Fragment>
          ))}
        </Grid>
      </Box>
    </Box>
  );
}

export default ViewCoveredMedicationsAndDrugs;
